import PropTypes from 'prop-types'
import Image from 'components/LegacyImage'
import styles from './NameplateImage.module.scss'

const NameplateImage = ({ alt, sizes, src }) => (
  <div className={styles.container}>
    <Image
      alt={alt}
      className={styles.image}
      layout='fill'
      sizes={sizes}
      src={src}
    />
  </div>
)

NameplateImage.propTypes = {
  alt: PropTypes.string,
  sizes: PropTypes.string,
  src: PropTypes.string,
}

export default NameplateImage
